export default __webpack_public_path__ + "static/media/ubereats.52fe505c.png";